// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================
ANALYTICS DASHBOARD STYLES
client/src/styles/AnalyticsDashboard.css
================================================ */

.analytics-dashboard {
  padding: 2rem;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

/* Header */
.dashboard-header {
  margin-bottom: 2rem;
  text-align: center;
}

.dashboard-header h1 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin: 0 0 0.5rem 0;
  font-weight: 700;
}

.dashboard-header p {
  color: #7f8c8d;
  font-size: 1rem;
}

/* Metrics Grid */
.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.metric-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border-left: 5px solid #3498db;
}

.metric-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.metric-card.blue {
  border-left-color: #3498db;
}

.metric-card.green {
  border-left-color: #2ecc71;
}

.metric-card.red {
  border-left-color: #e74c3c;
}

.metric-card.orange {
  border-left-color: #f39c12;
}

.metric-card.purple {
  border-left-color: #9b59b6;
}

.metric-icon {
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.metric-content {
  flex: 1 1;
}

.metric-title {
  margin: 0;
  font-size: 0.875rem;
  color: #7f8c8d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metric-value {
  margin: 0.5rem 0 0 0;
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
}

/* Tabs */
.tabs-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  border-bottom: 3px solid rgba(52, 152, 219, 0.1);
  padding-bottom: 1rem;
}

.tab-button {
  padding: 0.75rem 1.5rem;
  border: none;
  background: transparent;
  color: #7f8c8d;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  position: relative;
  top: 3px;
}

.tab-button:hover {
  color: #3498db;
}

.tab-button.active {
  color: #3498db;
  border-bottom-color: #3498db;
}

/* Tab Content */
.tab-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Section Container */
.section-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.section-container h2 {
  color: #2c3e50;
  font-size: 1.75rem;
  margin: 0;
  padding-bottom: 1rem;
  border-bottom: 2px solid #ecf0f1;
}

/* Cards */
.card {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.card h3 {
  margin: 0 0 1.5rem 0;
  color: #2c3e50;
  font-size: 1.25rem;
  font-weight: 600;
}

.card.full-width {
  grid-column: 1 / -1;
}

/* Grids */
.two-column-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 1rem;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #ecf0f1;
  transition: all 0.3s ease;
}

.stat-item:hover {
  border-color: #3498db;
  background: #eef6fc;
}

.stat-item .label {
  color: #7f8c8d;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.stat-item .value {
  color: #2c3e50;
  font-size: 1.75rem;
  font-weight: 700;
}

.stat-item .value.green {
  color: #2ecc71;
}

.stat-item .value.red {
  color: #e74c3c;
}

/* Tables */
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}

.data-table thead {
  background: #f8f9fa;
  border-bottom: 2px solid #ecf0f1;
}

.data-table th {
  padding: 1rem;
  text-align: left;
  color: #2c3e50;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.data-table td {
  padding: 1rem;
  border-bottom: 1px solid #ecf0f1;
  color: #34495e;
}

.data-table tbody tr:hover {
  background: #f8f9fa;
}

.data-table .count {
  text-align: center;
  font-weight: 600;
  color: #3498db;
}

.data-table .overdue {
  color: #e74c3c;
  font-weight: 600;
}

.data-table .overdue-row {
  background: #fadbd8;
}

/* Priority Badge */
.priority-badge {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.priority-badge.p1 {
  background: #fadbd8;
  color: #c0392b;
}

.priority-badge.p2 {
  background: #ffeaa7;
  color: #d63031;
}

.priority-badge.p3 {
  background: #dfe6e9;
  color: #2d3436;
}

/* Tag Container */
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1rem;
}

.tag-badge {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.tag-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* No Data Message */
.no-data {
  text-align: center;
  color: #95a5a6;
  padding: 2rem;
  font-style: italic;
}

/* Stat Box */
.stat-box {
  background: #f8f9fa;
  border-left: 4px solid #3498db;
  padding: 1.5rem;
  border-radius: 8px;
}

.stat-box p {
  margin: 0.5rem 0;
  color: #34495e;
}

.stat-box p strong {
  color: #2c3e50;
  font-size: 1.25rem;
}

/* Loading & Error States */
.analytics-loading,
.analytics-error {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
}

.analytics-error {
  background: #fadbd8;
  color: #c0392b;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .two-column-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .analytics-dashboard {
    padding: 1rem;
  }

  .dashboard-header h1 {
    font-size: 1.75rem;
  }

  .metrics-grid {
    grid-template-columns: 1fr;
  }

  .tabs-container {
    flex-direction: column;
  }

  .tab-button {
    width: 100%;
    text-align: left;
  }

  .data-table {
    font-size: 0.85rem;
  }

  .data-table th,
  .data-table td {
    padding: 0.75rem;
  }

  .stat-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .metric-card {
    flex-direction: column;
    text-align: center;
  }

  .metric-icon {
    font-size: 1.5rem;
  }

  .metric-value {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .metric-card {
    padding: 1rem;
  }

  .stat-grid {
    grid-template-columns: 1fr;
  }

  .tag-container {
    gap: 0.5rem;
  }

  .tag-badge {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
  }
}

/* Print Styles */
@media print {
  .analytics-dashboard {
    background: white;
  }

  .tab-button,
  .tabs-container {
    display: none;
  }

  .metric-card,
  .card {
    page-break-inside: avoid;
    box-shadow: none;
    border: 1px solid #ddd;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/AnalyticsDashboard.css"],"names":[],"mappings":"AAAA;;;kDAGkD;;AAElD;EACE,aAAa;EACb,6DAA6D;EAC7D,iBAAiB;EACjB,yGAAyG;AAC3G;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,wBAAwB;IACxB,gBAAgB;IAChB,sBAAsB;EACxB;AACF","sourcesContent":["/* ================================================\nANALYTICS DASHBOARD STYLES\nclient/src/styles/AnalyticsDashboard.css\n================================================ */\n\n.analytics-dashboard {\n  padding: 2rem;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n}\n\n/* Header */\n.dashboard-header {\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.dashboard-header h1 {\n  font-size: 2.5rem;\n  color: #2c3e50;\n  margin: 0 0 0.5rem 0;\n  font-weight: 700;\n}\n\n.dashboard-header p {\n  color: #7f8c8d;\n  font-size: 1rem;\n}\n\n/* Metrics Grid */\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.metric-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border-left: 5px solid #3498db;\n}\n\n.metric-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.metric-card.blue {\n  border-left-color: #3498db;\n}\n\n.metric-card.green {\n  border-left-color: #2ecc71;\n}\n\n.metric-card.red {\n  border-left-color: #e74c3c;\n}\n\n.metric-card.orange {\n  border-left-color: #f39c12;\n}\n\n.metric-card.purple {\n  border-left-color: #9b59b6;\n}\n\n.metric-icon {\n  font-size: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.metric-content {\n  flex: 1;\n}\n\n.metric-title {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #7f8c8d;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.metric-value {\n  margin: 0.5rem 0 0 0;\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2c3e50;\n}\n\n/* Tabs */\n.tabs-container {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n  border-bottom: 3px solid rgba(52, 152, 219, 0.1);\n  padding-bottom: 1rem;\n}\n\n.tab-button {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  background: transparent;\n  color: #7f8c8d;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-bottom: 3px solid transparent;\n  position: relative;\n  top: 3px;\n}\n\n.tab-button:hover {\n  color: #3498db;\n}\n\n.tab-button.active {\n  color: #3498db;\n  border-bottom-color: #3498db;\n}\n\n/* Tab Content */\n.tab-content {\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Section Container */\n.section-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.section-container h2 {\n  color: #2c3e50;\n  font-size: 1.75rem;\n  margin: 0;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #ecf0f1;\n}\n\n/* Cards */\n.card {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.card h3 {\n  margin: 0 0 1.5rem 0;\n  color: #2c3e50;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.card.full-width {\n  grid-column: 1 / -1;\n}\n\n/* Grids */\n.two-column-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.stat-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 1rem;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 2px solid #ecf0f1;\n  transition: all 0.3s ease;\n}\n\n.stat-item:hover {\n  border-color: #3498db;\n  background: #eef6fc;\n}\n\n.stat-item .label {\n  color: #7f8c8d;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.stat-item .value {\n  color: #2c3e50;\n  font-size: 1.75rem;\n  font-weight: 700;\n}\n\n.stat-item .value.green {\n  color: #2ecc71;\n}\n\n.stat-item .value.red {\n  color: #e74c3c;\n}\n\n/* Tables */\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.95rem;\n}\n\n.data-table thead {\n  background: #f8f9fa;\n  border-bottom: 2px solid #ecf0f1;\n}\n\n.data-table th {\n  padding: 1rem;\n  text-align: left;\n  color: #2c3e50;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 0.85rem;\n  letter-spacing: 0.5px;\n}\n\n.data-table td {\n  padding: 1rem;\n  border-bottom: 1px solid #ecf0f1;\n  color: #34495e;\n}\n\n.data-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.data-table .count {\n  text-align: center;\n  font-weight: 600;\n  color: #3498db;\n}\n\n.data-table .overdue {\n  color: #e74c3c;\n  font-weight: 600;\n}\n\n.data-table .overdue-row {\n  background: #fadbd8;\n}\n\n/* Priority Badge */\n.priority-badge {\n  display: inline-block;\n  padding: 0.4rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.priority-badge.p1 {\n  background: #fadbd8;\n  color: #c0392b;\n}\n\n.priority-badge.p2 {\n  background: #ffeaa7;\n  color: #d63031;\n}\n\n.priority-badge.p3 {\n  background: #dfe6e9;\n  color: #2d3436;\n}\n\n/* Tag Container */\n.tag-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.tag-badge {\n  display: inline-block;\n  padding: 0.5rem 1rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.tag-badge:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n/* No Data Message */\n.no-data {\n  text-align: center;\n  color: #95a5a6;\n  padding: 2rem;\n  font-style: italic;\n}\n\n/* Stat Box */\n.stat-box {\n  background: #f8f9fa;\n  border-left: 4px solid #3498db;\n  padding: 1.5rem;\n  border-radius: 8px;\n}\n\n.stat-box p {\n  margin: 0.5rem 0;\n  color: #34495e;\n}\n\n.stat-box p strong {\n  color: #2c3e50;\n  font-size: 1.25rem;\n}\n\n/* Loading & Error States */\n.analytics-loading,\n.analytics-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.analytics-error {\n  background: #fadbd8;\n  color: #c0392b;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .metrics-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .two-column-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .analytics-dashboard {\n    padding: 1rem;\n  }\n\n  .dashboard-header h1 {\n    font-size: 1.75rem;\n  }\n\n  .metrics-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .tabs-container {\n    flex-direction: column;\n  }\n\n  .tab-button {\n    width: 100%;\n    text-align: left;\n  }\n\n  .data-table {\n    font-size: 0.85rem;\n  }\n\n  .data-table th,\n  .data-table td {\n    padding: 0.75rem;\n  }\n\n  .stat-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .metric-card {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .metric-icon {\n    font-size: 1.5rem;\n  }\n\n  .metric-value {\n    font-size: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .metric-card {\n    padding: 1rem;\n  }\n\n  .stat-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .tag-container {\n    gap: 0.5rem;\n  }\n\n  .tag-badge {\n    font-size: 0.8rem;\n    padding: 0.4rem 0.8rem;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .analytics-dashboard {\n    background: white;\n  }\n\n  .tab-button,\n  .tabs-container {\n    display: none;\n  }\n\n  .metric-card,\n  .card {\n    page-break-inside: avoid;\n    box-shadow: none;\n    border: 1px solid #ddd;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
